const url = encodeURIComponent(window.location.href)
export const shareUrls = {
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  telegram: `https://t.me/share/url?url=${url}`,
  whatsapp: `https://web.whatsapp.com/send?text=${url}`,
}
